import styled from 'styled-components/macro';
import { FieldErrorIndicator } from '../../shared/form/FieldErrorIndicator';
import { RightAlignedTd, RightAlignedTh, Td, Th } from '../../shared/Table';
import { colourRed06 } from '../../styling/colours';
import { spacing03 } from '../../styling/spacing';

export const DragHandleTh = styled(Th)`
  width: 40px;
`;

export const DragHandleTd = styled(Td)`
  width: 40px;
`;

export const PartCodeTh = styled(Th)`
  width: 175px;
`;

export const PartCodeTd = styled(Td)`
  width: 175px;
`;

export const QuantityTh = styled(Th)`
  width: 150px;
`;

export const QuantityTd = styled(Td)`
  width: 150px;
`;

export const DescriptionTh = styled(Th)`
  width: 100%;
`;

export const DescriptionTd = styled(Td)`
  width: 100%;
`;

export const UnitTh = styled(Th)`
  width: 175px;
`;

export const UnitTd = styled(Td)`
  width: 175px;
`;

export const CurrencyTh = styled(RightAlignedTh)`
  width: 120px;
`;

export const CurrencyTd = styled(RightAlignedTd)`
  width: 120px;
  letter-spacing: 1px;
`;

export const ActionButtonTh = styled(Th)`
  width: 100px;
`;

export const ActionButtonTd = styled(Td)`
  width: 100px;
`;

export const ActionButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const PartCodeContainer = styled.div<{ $hasError: boolean }>`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  color: ${props => (props.$hasError ? colourRed06 : undefined)};
`;

export const InactivePartErrorIndicator = styled(FieldErrorIndicator)`
  margin-left: ${spacing03};
`;
